<template>
  <div class="license-container">
    <h1 class="license-title" v-if="vendorImg">供应商营业执照</h1>
    <div class="license-img-box" v-if="vendorImg">
      <div
        class="img-license"
        v-bind:style="{ backgroundImage: `url(${vendorImg})` }"
      ></div>
      <div class="watermark-text">仅用于叮咚买菜商品溯源使用</div>
    </div>
    <h1 class="license-title" v-if="animalQuarantineUrls.length > 0">
      动物检疫合格证明
    </h1>
    <template v-if="animalQuarantineUrls.length > 0">
      <div
        class="license-img-box"
        :key="index"
        v-for="(item, index) in animalQuarantineUrls"
      >
        <div
          class="img-license"
          v-bind:style="{ backgroundImage: `url(${item})` }"
        ></div>
        <div class="watermark-text">仅用于叮咚买菜商品溯源使用</div>
      </div>
    </template>
    <div class="license-footer">
      <img
        class="text-license"
        src="../assets/img-slogan@1x.png"
        alt="叮咚买菜为您的食品安全保驾护航"
        srcset="../assets/img-slogan@2x.png"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      waterMarkImg: ""
    };
  },
  props: {
    vendorImg: {
      type: String,
      default: ""
    },
    animalQuarantineUrls: {
      type: Array,
      default: () => {
        return [];
      }
    }
  }
};
</script>

<style lang="less">
.license-container {
  padding: 0 55px 13.5px;
  text-align: center;
  .license-title {
    color: #fff;
    font-size: 16px;
    display: inline-block;
    line-height: 28px;
    padding: 0 18.5px;
    box-shadow: 5px 5px 0 0 #cef6d8;
    margin-bottom: 12px;
    background-color: #33c658;
    border-radius: 21.5px;
    font-weight: 500;
  }
  .license-img-box {
    box-shadow: 0px 0px 16px 0px rgba(4, 147, 94, 0.16);
    margin-bottom: 26px;
    height: 166.5px;
    position: relative;
    overflow: hidden;
    .img-license {
      width: 100%;
      height: 100%;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    }
  }
  .license-footer .text-license {
    width: 100%;
    height: auto;
  }
}

.watermark-text {
  position: absolute;
  top: 65px;
  left: 10px;
  font-size: 17px;
  -webkit-text-fill-color: rgba(255, 255, 255, 0.68);
  -webkit-text-stroke: 1px rgba(196, 196, 196, 0.68);
  transform: rotate(-20deg);
}
</style>
